import { Button } from '@treasuryspring/spring-ui';
import { Download } from 'lucide-react';
import { useState } from 'react';

import { useRatesQuery } from '@/api/query';
import { useAppStore } from '@/stores/useAppStore';
import { formatYieldConvention } from '@/utils/helper-functions';

import Disclaimer from './disclaimer';
import PdfModal from './pdf-modal';
import RatesChart from './rates-chart';
import StateSelectors from './state-selectors';
import Valuation from './valuation';

export default function RateCard() {
  const [isPdfModalOpen, setIsPdfModalOpen] = useState(false);
  const { lastRefreshed } = useAppStore();
  const { yieldConvention } = useRatesQuery().data || {
    yieldConvention: 'APY',
  };

  return (
    <div className="max-w-page-break m-auto mt-44 mb-44 w-10/12 md:w-7/12">
      <h1 className="text-h1 mb-m whitespace-nowrap">Best Rates</h1>
      <div className="mb-m md:gap-xl gap-s flex w-full flex-col items-stretch justify-between md:flex-row md:items-center">
        <StateSelectors />
        <Button
          variant="secondary"
          size="small"
          icon={<Download />}
          onClick={() => setIsPdfModalOpen(true)}
        >
          PDF
        </Button>
      </div>
      <RatesChart />
      <Valuation className="mt-xl mb-xxl" />
      <div className="mt-l gap-xl flex justify-between">
        <div className="gap-xxs flex flex-col">
          {!!yieldConvention && (
            <p className="text-body-sm">
              All rates are shown in
              <strong>{` ${formatYieldConvention(yieldConvention)}`}</strong>
            </p>
          )}
          <p className="text-body-sm">ext = Extendable</p>
        </div>
        <p className="text-body-sm text-description">
          Last refreshed <strong>{lastRefreshed || '-'}</strong>
        </p>
      </div>
      <Disclaimer className="mt-s" />
      <PdfModal isOpen={isPdfModalOpen} onOpenChange={setIsPdfModalOpen} />
    </div>
  );
}
